import { useState } from "react";
import { useCallback } from "react";

export function useAppProvider() {
  const [isAdminDrawerOpen, setAdminDrawerOpen] = useState<boolean>(false);
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);
  const [isCartOpen, setCartOpen] = useState<boolean>(false);
  const [isCountryDialogOpened, setIsCountryDialogOpened] =
    useState<boolean>(false);

  const toggleAdminDrawer = useCallback(() => {
    setAdminDrawerOpen((prevOpen) => !prevOpen);
  }, [setAdminDrawerOpen]);

  const toggleMenu = useCallback(() => {
    setMenuOpen((prevOpen) => !prevOpen);
  }, [setMenuOpen]);

  const toggleCart = useCallback(() => {
    setCartOpen((prevOpen) => !prevOpen);
  }, [setCartOpen]);

  const openCart = useCallback(() => {
    setCartOpen(true);
  }, [setCartOpen]);

  const closeCart = useCallback(() => {
    setCartOpen(false);
  }, [setCartOpen]);

  return {
    data: {
      isCartOpen,
      isMenuOpen,
      isAdminDrawerOpen,
      isCountryDialogOpened,
    },
    actions: {
      openCart,
      closeCart,
      toggleCart,
      toggleMenu,
      toggleAdminDrawer,
      setIsCountryDialogOpened,
    },
  };
}
